<div class="yard-simulator">
  <sc-master-detail [selection]="[selectedMenuEntry]" [data]="menuEntries" [showDelete]="false" [readOnly]="true" [newStyle]="true"
    (selectionChanged)="onSimulatorMenuEntryChanged($event)">
    <div class="component">
      @switch (selectedMenuEntry.identifier) {
        @case ('number-plate-scan') {
          <app-number-plate-scan></app-number-plate-scan>
        }
        @case ('rfid-reader') {
          <app-rfid-reader></app-rfid-reader>
        }
        @case ('barcode-reader') {
          <app-barcode-reader></app-barcode-reader>
        }
      }
    </div>
  </sc-master-detail>
</div>
